/**
 * homePathForRole — where to send a user immediately after login, based on
 * their role. Office roles land on the operations dashboard ("/"); field
 * and self-service roles go straight to their dedicated shell instead of
 * the office AppShell.
 */
export function homePathForRole(role?: string | null): string {
  switch (role) {
    case "system_admin":
      return "/admin/health";
    case "customer":
      return "/portal";
    case "village_chairman":
      return "/vc";
    case "technician":
      return "/field/installations";
    case "sales_rep":
      return "/field/leads";
    default:
      return "/";
  }
}
